<template>
  <BaseToggle
    v-model:is-checked="localDevice.isAutomatedMeterReading"
    label="Beyonnex Funkkompatibel"
    test-id="is-automated-meter-reading"
  />
</template>

<script setup lang="ts">
import { computed, WritableComputedRef } from 'vue';
import BaseToggle from '@/components/UI/Switch/BaseToggle.vue';
import { DeviceClasses } from '@/models/devices/Device';

const props = defineProps<{
  device: DeviceClasses;
}>();

const emit = defineEmits(['update:device']);

const localDevice: WritableComputedRef<DeviceClasses> = computed({
  get() {
    return props.device;
  },
  set(value) {
    emit('update:device', value);
  },
});
</script>
